import React from 'react';
import { Header } from './components/Header';
import { Advertorial } from './components/Advertorial';
import { AmbassadorSection } from './components/AmbassadorSection';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  return <div className="bg-white w-full" data-id="element-0">
      <FacebookPixel data-id="element-1" />
      <Header data-id="element-2" />
      <Advertorial data-id="element-3" />
      <AmbassadorSection data-id="element-4" />
    </div>;
}